module.exports = __webpack_public_path__ + "img/ys3.266b87f3.jpg";